import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";

const BikeDesignCompThankYouScreen = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center my-5 py-5 container">
      <div className="mb-5">
        <Icon
          icon="mdi:tick-circle"
          style={{
            color: "#10B068",
            width: "7.5em",
            height: "7.5em",
          }}
        />
      </div>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <h5 className="metropolis-medium mb-3 text-center">
           Thank you for registering!
        </h5>
        <p className="text-muted text-center col-md-8">
          We’ve sent a confirmation email with next steps and deadlines.Start
          brainstorming your design could define the future of biking!
        </p>
      </div>
    </div>
  );
};

export default BikeDesignCompThankYouScreen;
